/* @flow */

import React from 'react';

import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

import IntlMessageComponent from 'components/formatters/intlMessage';

import { SUPPLIER_STATUS_ACTIVE, SUPPLIER_STATUS_INACTIVE, SUPPLIER_STATUS_INFOSUBMITTED, SUPPLIER_STATUS_MISSINGINFO } from 'constants/constants';

const useStyles = makeStyles(_ => ({
  label: {
    textTransform: 'uppercase'
  }
}));

type SupplierStatusStatusViewComponentProps = {
  statusKey: string;
}

export default function SupplierStatusStatusViewComponent(props: SupplierStatusStatusViewComponentProps) {
  const classes = useStyles();

  const customize = (statusKey: string) => {
    switch (statusKey) {
      case SUPPLIER_STATUS_MISSINGINFO:
        return { color: 'red.main', translationId: 'supplier.status.missinginfo' };
      case SUPPLIER_STATUS_INFOSUBMITTED:
        return { color: 'orange.main', translationId: 'supplier.status.infosubmitted' };
      case SUPPLIER_STATUS_ACTIVE:
        return { color: 'green.main', translationId: 'supplier.status.active' };
      case SUPPLIER_STATUS_INACTIVE:
        return { color: 'grey.main', translationId: 'supplier.status.inactive' };
      default:
        return { color: 'grey.main', translationId: 'general.unknown' };
    }
  }

  const data = customize(props.statusKey);

  return (
    <Box
      alignItems="center"
      color={data.color}
      display="flex"
      fontSize="0.9em"
      fontWeight="fontWeightBold"
    >
      {data.icon}
      <Box component="span" className={classes.label} ml={1}>
        <IntlMessageComponent id={data.translationId} />
      </Box>
    </Box>
  );
}